// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3nAbn","productName":"Table_productName__1b1zv"};